import { useLocation } from 'react-router-dom';

export const useQuery = () => new URLSearchParams(useLocation().search);

export const useCreateUrlWithQuery = (url, params) => {
  const query = new URLSearchParams(params);
  return `${url}?${query.toString().split('%2C').join(',')}`;
};
